import { render, staticRenderFns } from "./tentant.vue?vue&type=template&id=55cf911a&scoped=true&"
import script from "./tentant.vue?vue&type=script&lang=ts&"
export * from "./tentant.vue?vue&type=script&lang=ts&"
import style0 from "./tentant.vue?vue&type=style&index=0&id=55cf911a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf911a",
  null
  
)

export default component.exports